import { usePortalTranslate } from '@/hooks'

export const ItemTranslatedReturnReason = ({ reason }: { reason: string }) => {
  const { trans } = usePortalTranslate({})

  return (
    <span className="inline-block w-36 truncate font-sans">
      {trans(`select_reason_${reason}`)}
    </span>
  )
}
